import { CardLayout, SanityInfoBlockInstance, SanityTextAlign } from "@sourceful/shared-types";
import React from "react";
import InfoBlock from "@components/infoBlock";
import ResponsiveCarousel from "./ResponsiveCarousel";
import { PRODUCT_CARD_WIDTH } from "@components/productCard/genericProductCard";

const GRID_GAP = 30;

interface InfoBlockRowProps {
  hasGridGap: boolean;
  textAlign: SanityTextAlign;
  layout: CardLayout;
  widgets: SanityInfoBlockInstance[];
  constrainContent: boolean;
}

const InfoBlockRow = ({
  widgets,
  hasGridGap,
  textAlign,
  layout,
  constrainContent,
}: InfoBlockRowProps) => {
  return (
    <ResponsiveCarousel
      numItems={widgets.length}
      gridGap={hasGridGap ? GRID_GAP : 0}
      itemWidth={PRODUCT_CARD_WIDTH}
      constrainContent={constrainContent}
    >
      {widgets.map(widget => {
        return (
          <InfoBlock
            key={widget._key}
            item={widget}
            textAlign={textAlign}
            layout={layout}
            className="carousel-card info-block"
          />
        );
      })}
    </ResponsiveCarousel>
  );
};

export default InfoBlockRow;
